import { Minus, Plus } from '@phosphor-icons/react';

import { clampSelfieDay } from '../../utils/guidedFlowUtils';
import { cn } from '../../utils/cn';

export function CycleDayStepper({ value, onChange, className }) {
  const day = clampSelfieDay(value);

  const adjust = (delta) => {
    const next = ((day - 1 + delta + 31) % 31) + 1;
    onChange(next);
  };

  return (
    <div
      className={cn(
        'onboarding-focus-ring mt-space-5 flex items-center justify-between px-space-3 py-space-2-5',
        className,
      )}
    >
      <span className="type-body-sm text-muted-foreground">Dia do ciclo</span>
      <span className="flex items-center gap-space-4">
        <button
          type="button"
          onClick={() => adjust(-1)}
          aria-label="Menos"
          className="flex h-10 w-10 items-center justify-center rounded-ds-md border border-border bg-muted text-sage-700 transition active:bg-sage-50 dark:text-sage-300 dark:active:bg-sage-950/40"
        >
          <Minus className="h-4 w-4" weight="bold" aria-hidden />
        </button>
        <span className="type-display-metric min-w-[38px] text-center font-display font-bold tabular-nums text-foreground">
          {day}
        </span>
        <button
          type="button"
          onClick={() => adjust(1)}
          aria-label="Mais"
          className="flex h-10 w-10 items-center justify-center rounded-ds-md border border-border bg-muted text-sage-700 transition active:bg-sage-50 dark:text-sage-300 dark:active:bg-sage-950/40"
        >
          <Plus className="h-4 w-4" weight="bold" aria-hidden />
        </button>
      </span>
    </div>
  );
}
